
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KvkkPopupComponent } from './kvkkPopup.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        KvkkPopupComponent
    ],
    exports: [
        KvkkPopupComponent
    ]
})
export class KvkkPopupModule {

}
